'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createRestaurant;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createRestaurant() {
    var fixture = init();

    function init() {
        return {
            id: 'restaurantid',
            timezone: 'Asia/Jerusalem',
            availabilities: {}
        };
    }

    return {
        addTakeout: function addTakeout(_ref) {
            var minOrderPrice = _ref.minOrderPrice,
                delayMins = _ref.delayMins,
                availability = _ref.availability;

            fixture.deliveryInfos = fixture.deliveryInfos || [];
            fixture.deliveryInfos.push({ type: 'takeout', minOrderPrice: minOrderPrice, delayMins: delayMins, availability: availability });

            return this;
        },
        addDelivery: function addDelivery(_ref2) {
            var minOrderPrice = _ref2.minOrderPrice,
                delayMins = _ref2.delayMins,
                availability = _ref2.availability;

            fixture.deliveryInfos = fixture.deliveryInfos || [];
            fixture.deliveryInfos.push({ type: 'delivery', minOrderPrice: minOrderPrice, delayMins: delayMins, availability: availability });

            return this;
        },
        setOpenTimes: function setOpenTimes(_ref3) {
            var availability = _ref3.availability;

            fixture.openTimes = availability;
            return this;
        },
        addAvailabilityType: function addAvailabilityType(_ref4) {
            var type = _ref4.type,
                availability = _ref4.availability;

            fixture.availabilities[type] = availability;

            return this;
        },
        setOrders: function setOrders(_ref5) {
            var orders = _ref5.orders;

            fixture.orders = orders;
            return this;
        },
        setReservations: function setReservations(_ref6) {
            var reservations = _ref6.reservations;

            fixture.reservations = reservations;
            return this;
        },
        activateFutureOrders: function activateFutureOrders() {
            var maxDelayMins = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1440;

            fixture.maxFutureOrderDelayMins = maxDelayMins;
            _lodash2.default.set(fixture, 'orders.future.disabled', false);
            return this;
        },
        disableFutureOrders: function disableFutureOrders() {
            fixture.maxFutureOrderDelayMins = 0;
            _lodash2.default.set(fixture, 'orders.future.disabled', true);
            return this;
        },
        val: function val() {
            return fixture;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-restaurants-js-sdk/dist/fixtures/Restaurant.js
// module id = 712
// module chunks = 0